var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M427.023,59.858H84.977c-13.851,0-25.119,11.268-25.119,25.119v401.904 c0,13.851,11.268,25.119,25.119,25.119h342.046c13.851,0,25.119-11.268,25.119-25.119V84.977 C452.142,71.126,440.874,59.858,427.023,59.858z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M93.528,470.313c0,4.427,3.589,8.017,8.017,8.017h290.739c4.427,0,8.017-3.589,8.017-8.017V77.934 c0-4.965-4.025-8.99-8.99-8.99H102.519c-4.965,0-8.99,4.025-8.99,8.99V470.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M436.109,503.983H94.063c-13.851,0-25.119-11.268-25.119-25.119V76.96 c0-5.296,1.651-10.211,4.46-14.267c-8.04,4.193-13.546,12.604-13.546,22.283v401.904c0,13.851,11.268,25.119,25.119,25.119h342.046 c8.554,0,16.12-4.301,20.659-10.852C444.215,502.955,440.28,503.983,436.109,503.983z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F6F7"
    },
    d: "M102.079,461.228c0,4.427,3.589,8.017,8.017,8.017h290.739c4.427,0,8.017-3.589,8.017-8.017V77.934 c0-4.965-4.025-8.99-8.99-8.99H111.07c-4.965,0-8.99,4.025-8.99,8.99V461.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M163.541,110.63h188.125c10.314,0,18.706-8.392,18.706-18.706V68.944H144.835v22.981 C144.835,102.239,153.227,110.63,163.541,110.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC44F"
    },
    d: "M332.96,34.205h-35.502C293.703,14.743,276.542,0,256,0c-20.541,0-37.703,14.743-41.458,34.205 H179.04c-13.851,0-25.119,11.268-25.119,25.119v34.205c0,4.427,3.589,8.017,8.017,8.017h188.125c4.428,0,8.017-3.589,8.017-8.017 V59.324C358.079,45.473,346.811,34.205,332.96,34.205z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B14D"
    },
    d: "M260.008,0.192C258.688,0.067,257.352,0,256,0c-20.541,0-37.703,14.743-41.458,34.205h8.017 C226.067,16.024,241.275,1.966,260.008,0.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B14D"
    },
    d: "M161.937,93.528V59.324c0-13.851,11.268-25.119,25.119-25.119h-8.017 c-13.851,0-25.119,11.268-25.119,25.119v34.205c0,4.427,3.589,8.017,8.017,8.017h8.017 C165.527,101.545,161.937,97.956,161.937,93.528z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF722A"
    },
    d: "M256,50.238c-4.427,0-8.017-3.589-8.017-8.017V33.67c0-4.427,3.589-8.017,8.017-8.017 c4.428,0,8.017,3.589,8.017,8.017v8.551C264.017,46.649,260.428,50.238,256,50.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DF7A6E"
    },
    d: "M356.808,316.761l-85.512-171.023c-2.897-5.794-8.818-9.454-15.297-9.454 c-6.479,0-12.4,3.66-15.297,9.454l-85.511,171.023c-4.224,8.447-0.8,18.721,7.649,22.945c8.445,4.223,18.721,0.799,22.945-7.649 l33.754-67.506h72.923l33.754,67.506c2.996,5.993,9.035,9.459,15.31,9.458c2.57,0,5.18-0.581,7.635-1.809 C357.608,335.482,361.033,325.209,356.808,316.761z M236.64,230.347L256,191.628l19.36,38.719H236.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8C78"
    },
    d: "M350.063,145.37h-9.086v-9.086c0-4.427-3.588-8.017-8.017-8.017c-4.428,0-8.017,3.589-8.017,8.017 v9.086h-9.086c-4.428,0-8.017,3.589-8.017,8.017c0,4.427,3.588,8.017,8.017,8.017h9.086v9.086c0,4.427,3.588,8.017,8.017,8.017 c4.428,0,8.017-3.589,8.017-8.017v-9.086h9.086c4.428,0,8.017-3.589,8.017-8.017C358.079,148.959,354.491,145.37,350.063,145.37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M324.409,392.284H187.591c-4.427,0-8.017-3.589-8.017-8.017c0-4.427,3.589-8.017,8.017-8.017 h136.818c4.428,0,8.017,3.589,8.017,8.017C332.426,388.695,328.838,392.284,324.409,392.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M264.551,426.489h-76.96c-4.427,0-8.017-3.589-8.017-8.017c0-4.427,3.589-8.017,8.017-8.017h76.96 c4.428,0,8.017,3.589,8.017,8.017C272.568,422.899,268.98,426.489,264.551,426.489z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIcon);
export default __webpack_public_path__ + "static/media/result-icon.a66f40af7f46b47903469c040fa22e10.svg";
export { ForwardRef as ReactComponent };